import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { 
  supportPageStyles, 
  contentSectionStyles 
} from './styles';
import HeroSection from './components/HeroSection';
import ContactOptions from './components/ContactOptions';
import HelpSection from './components/HelpSection';
import ContactForm from './components/ContactForm';
import FAQ from './components/FAQ';
import LegalLinks from './components/LegalLinks';

const APP_VERSION = '0.2';

export const Support = () => {
  const { t } = useTranslation();
  
  return (
    <Box sx={supportPageStyles.container}>
      {/* Sección Hero con fondo azul marino */}
      <HeroSection />
      
      {/* Sección de contenido principal */}
      <Box sx={contentSectionStyles.container}>
        <Box sx={contentSectionStyles.wrapper}>
          
          {/* Opciones de contacto */}
          <ContactOptions />
          
          {/* Sección "Te ayudamos con" */}
          <HelpSection />
          
          {/* Formulario de contacto */}
          <ContactForm />
          
          {/* FAQ */}
          <FAQ />
          
          {/* Enlaces legales */}
          <LegalLinks />
          
        </Box>
      </Box>
    </Box>
  );
};

export default Support; 